class MockAuth {
  _isSignedIn = false;
  confirmSignUp = () => {};
  signUp = () => {};
  signIn = () => {};
  currentUserCredentials = () => {};
  currentSession = () => {
    if (!this._isSignedIn) {
      return Promise.reject("not signed in");
    }

    return Promise.resolve({});
  };
  signOut = () => {};
}

export default new MockAuth();
